export const base_url =
  window.location.hostname === "localhost"
    ? "http://localhost:5644/"
    : window.location.protocol + "//" + window.location.hostname + "/backend/";

    // ====Roles======
    export const PMS_ADMIN = 1;
    export const PRINCIPAL_INVESTIGATOR = 2;
    export const MARKETING_STAFF = 6;
    export const QUALITY_REVIEWER = 4;
    export const MEDICAL_REVIEWER = 5;
    export const MARKETING_HEAD = 3;
    // AE Bank 
    export const EVENT_CLASSIFICATION_LEVEL_BRIGHTON = 0; //level
    export const EVENT_CLASSIFICATION_GRADE_CTCAE = 1; //grade
    export const EVENT_CLASSIFICATION_AESI =2; //AESI 
    export const EVENT_CLASSIFICATION_OTHER = 5; //Other
    export const EVENT_MEETS_CASE = 3;
    export const EVENT_DOESNT_MEETS_CASE = 4;
    export const CRYPTO_SECRET_KEY = "8DQ1DABA8A4EE292A832E4C5BB7WC";
    export const TINY_API_KEY="wusymvu2v1cl6iowwhe92ycgdiwn3ls2eeqj3kzemimlqt47"

    export const SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT =1;
    export const SUBJECT_STATUS_ON_STUDY=2;
    export const SUBJECT_STATUS_OFF_STUDY=3;

    export const TOGGLE_YES = 1;
    export const TOGGLE_NO = 0;

    export const PI_ADDED_SUBJECT = "2.1"
    export const QR_SUBJECT_REVIEW_APPROVED = "4.1"
    export const QR_SUBJECT_REVIEW_REJECTED = "4.2"
    export const PI_NEW_EVENT_REPORTED = "2.2"
    export const PI_NEW_SERIOUS_EVENT_REPORTED = "2.3"
    export const QR_EVENT_APPROVED = "4.3"
    export const QR_EVENT_REJECTED = "4.4"
    export const MR_EVENT_APPROVED = "5.1"
    export const MR_EVENT_SENT_BACK_TO_PI = "5.2"
    export const MR_EVENT_SENT_BACK_TO_QR = "5.3"
    export const AD_NEW_SITE_CREATED = "1.1"
    export const PI_UPDATED_EVENT = "2.4"
    export const PI_UPDATED_SUBJECT = "2.5"



export const EVENT_STATUS_WAITING_FOR_REVIEW= 0;
export const EVENT_STATUS_IN_PROGRESS= 1;
export const EVENT_STATUS_REVIEWED= 2;
export const EVENT_STATUS_SENT_BACK_FOR_REVIEW= 3;
// subjData

export const SUBJECT_REVIEW_STATUS_WAITING_FOR_REVIEW= 0;
export const SUBJECT_REVIEW_STATUS_IN_PROGRESS= 1;
export const SUBJECT_REVIEW_STATUS_REVIEWED= 2;
export const SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW= 3;
export const SUBJECT_REVIEW_STATUS_NOT_TO_BE_INTIMATED= -1;


export const MEDDRA_ALLERGIES= 1;
    export const MEDDRA_MEDICAL_HISTORY= 2;
    export const MEDDRA_CONCURRENT_ILLNESS= 3;


    export const WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS= 1;
    export const WHODD_CONCOMITANT_MEDICATION= 2;
    export const WHODD_ADVERSE_EVENT= 3;
 